import { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Printer } from "lucide-react";

/**
 * Card in Impostazioni to display and print a GENERIC warranty QR code.
 * The same QR can be printed on bulk stickers and applied to every dispenser
 * before shipping. Customers scan it, then enter/scan the serial on the page.
 */
export function GenericWarrantyQrCard() {
  const url = `${window.location.origin}/garanzia`;
  const svgId = "generic-warranty-qr-svg";

  const printQR = () => {
    const w = window.open("", "_blank", "width=600,height=800");
    if (!w) return;
    const svg = document.getElementById(svgId);
    const doc = w.document;
    doc.title = "Wineemotion — Warranty QR";
    const style = doc.createElement("style");
    style.textContent = "body{font-family:Inter,sans-serif;text-align:center;padding:40px;color:#111}"
      + "h1{font-size:22px;margin:8px 0;letter-spacing:-0.02em}"
      + ".sn{font-family:monospace;font-size:12px;color:#666;letter-spacing:0.1em;text-transform:uppercase}"
      + ".box{border:1px solid #ddd;padding:24px;display:inline-block;margin-top:20px}"
      + "p{color:#444;font-size:12px;max-width:280px;margin:16px auto;line-height:1.5}";
    doc.head.appendChild(style);
    const mk = (tag, text, cls) => { const el = doc.createElement(tag); if (cls) el.className = cls; el.textContent = text; return el; };
    doc.body.appendChild(mk("div", "WINEEMOTION", "sn"));
    doc.body.appendChild(mk("h1", "Warranty Registration"));
    const box = doc.createElement("div"); box.className = "box";
    if (svg) box.appendChild(doc.importNode(svg, true));
    doc.body.appendChild(box);
    doc.body.appendChild(mk("p", "Scan this code to register your warranty. Enter or scan the dispenser serial number on the page. Please do this the first time you install the dispenser."));
    setTimeout(() => w.print(), 400);
  };

  return (
    <Card className="rounded-sm border-zinc-200 bg-white p-6" data-testid="settings-generic-warranty-qr">
      <div className="flex items-start gap-3 mb-4">
        <div className="h-10 w-10 rounded-sm bg-brand-muted text-brand flex items-center justify-center shrink-0">
          <ShieldCheck className="h-5 w-5" strokeWidth={1.75} />
        </div>
        <div className="flex-1">
          <h3 className="font-display text-lg font-semibold tracking-tight text-zinc-900">QR generico registrazione garanzia</h3>
          <p className="text-sm text-zinc-600">Stampa questo QR in blocchi e applicalo a tutti i dispenser prima della spedizione. Il cliente inserirà (o scansionerà) il seriale sulla pagina di registrazione.</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-6 pt-2">
        <div className="border border-zinc-200 rounded-sm p-4 bg-white">
          <QRCodeSVG id={svgId} value={url} size={180} level="M" />
        </div>
        <div className="flex-1 min-w-0 text-center sm:text-left">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1">URL</div>
          <div className="text-xs font-mono text-zinc-800 break-all mb-3">{url}</div>
          <Button
            data-testid="print-generic-warranty-qr"
            onClick={printQR}
            className="bg-brand hover:bg-brand-dark text-white rounded-sm"
          >
            <Printer className="h-4 w-4 mr-2" /> Stampa etichetta
          </Button>
        </div>
      </div>
    </Card>
  );
}
